import React, { FC, useEffect } from 'react';
import { useAppSelector } from '../store';
import { useDispatch } from 'react-redux';
import { GuardFallback } from './model';
import { getTeamsContextThunk } from '../store/actions/conversation/thunks';
import {
    selectTeamMember,
    selectTeamsContext,
} from '../store/selectors/conversation';

type Props = {
    fallback?: GuardFallback;
    children: JSX.Element;
};

export const TeamContextGuard = ({
    children,
    fallback: _fallback,
}: Props): JSX.Element | null => {
    const dispatch = useDispatch();
    const teamsCtx = useAppSelector(selectTeamsContext);
    const teamMember = useAppSelector(selectTeamMember);

    const isTeamsCtxLoaded = Boolean(teamsCtx);
    const isChannelOrTeam = teamsCtx?.team?.groupId || teamsCtx?.channel?.id;

    useEffect(() => {
        dispatch(getTeamsContextThunk());
        // dispatch(fetchCirclesThunk());
    }, [dispatch]);

    if (!isTeamsCtxLoaded) {
        return null;
    }

    if (isChannelOrTeam && !teamMember) {
        return null;
    }

    return children;
};

export const withTeamContextGuard = <T extends Record<string, unknown>>(
    component: FC<T>,
    fallback?: GuardFallback,
): FC<T> =>
    function WithTeamContextGuard(props) {
        return (
            <TeamContextGuard fallback={fallback}>
                {React.createElement(component, props, props?.children)}
            </TeamContextGuard>
        );
    };
